import React from 'react';
import { IconProps } from '.';

const SvgCircleBlog = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Z' />
      <path
        fill='#fff'
        d='M4.5 13.946h1.819c.906 0 1.417-.46 1.417-1.086 0-.564-.429-.92-.92-.94v-.038c.446-.089.762-.395.762-.839 0-.591-.471-.99-1.39-.99H4.5v3.893Zm.96-.742v-.946h.65c.384-.003.621.194.621.5 0 .277-.2.446-.638.446H5.46Zm0-1.543v-.876h.582c.342 0 .553.167.553.43 0 .28-.237.444-.564.446h-.57ZM8.373 13.946h2.678V13.2H9.334v-3.145h-.96v3.892ZM15.225 12c.002-1.285-.848-2-1.944-2-1.1 0-1.942.715-1.942 2 0 1.277.841 2 1.942 2 1.096 0 1.946-.718 1.944-2Zm-2.904 0c0-.774.365-1.196.96-1.194.6-.002.963.42.96 1.194.004.774-.36 1.194-.96 1.194-.595 0-.96-.42-.96-1.194ZM18.483 11.323h.977c-.104-.777-.83-1.323-1.773-1.323-1.087 0-1.943.734-1.943 2.005 0 1.232.79 1.995 1.96 1.995 1.048 0 1.796-.624 1.796-1.661v-.511h-1.75v.672h.824c-.014.422-.32.694-.864.694-.619 0-.983-.439-.983-1.2 0-.755.381-1.19.983-1.188.403-.002.68.191.773.517Z'
      />
    </svg>
  );
};

export default SvgCircleBlog;
